import React from "react";
import { FaChartLine, FaRedo, FaTrophy, FaUsers } from "react-icons/fa";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-sky-200" />
      <p className="mt-3 font-titre text-3xl font-bold">{value}</p>
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function CoachStatsHero({ stats, refreshing, onRefresh }) {
  return (
    <header className="relative overflow-hidden bg-slate-950 pt-[88px] lg:pt-[104px]">
      <div className="absolute inset-0">
        <img
          src="/img/cover/cover_statistiques.webp"
          alt="Statistiques"
          className="h-full w-full object-cover opacity-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-blue-950/90 to-indigo-950/80" />
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-20 pt-10 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
              <FaChartLine />
              Analyse coach
            </div>

            <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl">
              Statistiques des judokas
            </h1>

            <p className="mt-4 max-w-3xl text-sm font-medium leading-7 text-white/70 sm:text-base">
              Analyse les compétitions, les combats, les podiums et les
              performances de tes groupes ou d’un judoka précis.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-bold text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaRedo className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Actualisation..." : "Actualiser"}
          </button>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <HeroStat icon={FaUsers} label="Judokas" value={stats.judokas} />
          <HeroStat
            icon={FaTrophy}
            label="Participations"
            value={stats.participations}
          />
          <HeroStat
            icon={FaChartLine}
            label="Taux victoire"
            value={`${stats.victoryRate}%`}
          />
          <HeroStat icon={FaTrophy} label="Podiums" value={stats.podiums} />
        </div>
      </div>
    </header>
  );
}

export default CoachStatsHero;